const createRules = {
    referenceNumber: 'required|max:50',
    consigneeName: 'required|max:50',
    consigneePhone: 'phone|max:50',
    consigneePhoneRequired: 'required|phone|max:50',
    consigneeEmail: 'email|max:50',
    consigneeEmailRequired: 'required|email|max:50',
    consigneeAddressLine1: 'required|max:50',
    consigneeAddressLine2: 'max:50',
    city: 'required|max:50',
    stateProvince: 'required|max:50',
    zipCode: 'max:50',
    zipCodeRequired: 'required|max:50',
    orderComments: 'max:500',
};

export {
    createRules,
};
export default {
    createRules,
};
